import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import FocusLock from "react-focus-lock";
import cx from "classnames";
import { CrossIcon } from "@cinch-nx/design-system-icons";
import { Modal, useModal } from "../modal";
import { CarReviewGallery } from "../car-review-gallery";
import styles from "./gallery-modal.module.css";
import { useVehicleGallery } from "../../hooks";
export function GalleryModal(param) {
    var _images = param.images, images = _images === void 0 ? [] : _images;
    var ref = useModal(), close = ref.close, isOpen = ref.isOpen;
    var imageIndex = useVehicleGallery().imageIndex;
    var prevFocusedElement = useRef(null);
    var closeButton = useRef(null);
    var ref1 = useState(0), currentSlide = ref1[0], setCurrentSlide = ref1[1];
    var updateCurrentPagination = function(details) {
        if (details.activeIndex !== undefined) {
            setCurrentSlide(details.activeIndex);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, {
        className: styles.galleryModal,
        onOpen: function() {
            return disableFocus(prevFocusedElement, closeButton);
        },
        onClose: function() {
            return resetFocus(prevFocusedElement);
        },
        children: /*#__PURE__*/ _jsx(FocusLock, {
            disabled: !isOpen,
            className: styles.fullWidth,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.galleryModalInner,
                "aria-label": "image-gallery",
                children: [
                    /*#__PURE__*/ _jsxs("header", {
                        className: cx(styles.galleryModalHeader, styles.uiColours),
                        children: [
                            /*#__PURE__*/ _jsxs("label", {
                                children: [
                                    currentSlide,
                                    " / ",
                                    images.length
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx("button", {
                                    className: styles.galleryModalCloseButton,
                                    onClick: function() {
                                        return close();
                                    },
                                    "aria-label": "Close",
                                    ref: closeButton,
                                    children: /*#__PURE__*/ _jsx(CrossIcon, {
                                        size: 24
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(CarReviewGallery, {
                        images: images,
                        updateGalleryPaginationNumber: updateCurrentPagination,
                        imageIndex: imageIndex
                    })
                ]
            })
        })
    });
}
function disableFocus(prevFocusedElementRef, closeButtonRef) {
    prevFocusedElementRef.current = document.activeElement;
    if (closeButtonRef.current) {
        closeButtonRef.current.focus();
        document.body.style.overflow = "hidden";
    }
}
function resetFocus(prevFocusedElementRef) {
    document.body.style.overflow = "unset";
    document.body.setAttribute("aria-hidden", "false");
    if (isHtmlElement(prevFocusedElementRef.current)) {
        prevFocusedElementRef.current.focus();
    }
}
function isHtmlElement(input) {
    return !!input && Object.prototype.hasOwnProperty.call(input, "focus");
}
